var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('commonHeader',{attrs:{"isactive":1}}),_c('homeSwiper'),_c('homeThree'),_c('selectAdvantage'),_c('flowpath'),_c('bottomSwiper'),_c('commonBottom'),_c('backTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }